import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('load', () => {
	const editionsTitle = document.querySelector('.editions__title')
	const editionsTitleWidth = editionsTitle.offsetWidth

	gsap.to(editionsTitle, {
		xPercent: -100,
		x: () => innerWidth,
		ease: 'none',
		scrollTrigger: {
			trigger: '.editions__x-scroll',
			start: 'center center',
			end: () => `+=${editionsTitleWidth}`,
			scrub: true,
			pin: true,
		},
	})
})
